import { Dispatch, SetStateAction } from 'react';
import styled from '@emotion/styled';
import useMediaQuery from '@mui/material/useMediaQuery';
import { webPalette } from 'src/themes';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';
import { transientOptions } from 'src/utils';
import { AuthLogo } from './AuthLogo';
import { NavBar } from './NavBar';

interface AuthSideBarProps {
  setIsOpen?: Dispatch<SetStateAction<boolean>>;
}

const SideBar = styled.aside`
  position: relative;
  width: 21rem;
  box-shadow: 0px 0px 80px #000000c7;
`;

interface SideBarContainerProps {
  $doesNavigationFit: boolean;
}

const SideBarContainer = styled(
  'div',
  transientOptions
)<SideBarContainerProps>(
  ({ $doesNavigationFit }) => `
  position: ${$doesNavigationFit ? 'fixed' : 'absolute'};
  background-color: ${webPalette.navbar};
  height: ${$doesNavigationFit ? '100vh' : 'auto'};
  display: flex;
  flex-direction: column;
`
);

export const AuthSideBar = ({ setIsOpen }: AuthSideBarProps) => {
  const { deviceHeight } = useWindowDimensions();
  const matches = useMediaQuery(`(min-height:${deviceHeight}px)`);

  return (
    <SideBar>
      <SideBarContainer $doesNavigationFit={matches}>
        <AuthLogo />
        <NavBar setIsOpen={setIsOpen} />
      </SideBarContainer>
    </SideBar>
  );
};
